module.exports = __webpack_public_path__ + "img/awaits.2fef5705.png";